import _ from 'lodash'

import type { WorkspaceSummaryResponse, HourlyWorkerRow } from 'api/dashboard'

import type { Moment } from 'moment'

export const NO_GROUP_ID = 0

export const getWorkerPerformance = (
  workspaceSummary: WorkspaceSummaryResponse | undefined,
  groupId: number,
  workerId: number,
  openMoment?: Moment
): 'bad' | 'normal' | 'good' => {
  const targetHour = openMoment ? openMoment.hour() - 1 : new Date().getHours() - 1
  const data = _.chain(workspaceSummary?.workspaceData.groups)
    .find(group => (groupId === NO_GROUP_ID ? group.groupId === null : group.groupId === groupId))
    .get('workers')
    .find({ workerId })
    .get('hourlyWorkerData')
    .flatMap<HourlyWorkerRow>('data')
    .filter(d => new Date(d.time).getHours() === targetHour)
    .value()
  const totalPlanCount = data.reduce((acc, cur) => acc + (cur.planCount || 0), 0)
  const totalRecordCount = data.reduce((acc, cur) => acc + (cur.recordCount || 0), 0)
  const performance = totalPlanCount === 0 ? 0 : Math.floor((totalRecordCount / totalPlanCount) * 100)
  if (totalPlanCount === 0 && totalRecordCount === 0) {
    return 'normal'
  } else if (performance < 90) {
    return 'bad'
  } else if (111 <= performance) {
    return 'good'
  }
  return 'normal'
}
